/* eslint-disable */
var dhtmlXCellTop = (function () {
    function dhtmlXCellTop(h, c) {
        if (arguments.length == 0 || typeof (h) == "undefined") {
            return;
        }
        var a = this;
        this.dataNodes = {};
        this.conf.ofs = { t: 0, b: 0, l: 0, r: 0 };
        this.conf.ofs_nodes = { t: {}, b: {} };
        this.conf.progress = false;
        this.conf.fs_mode = false;
        this.conf.fs_tm = null;
        this.conf.fs_resize = false;
        if (h == document.body) {
            this.conf.fs_mode = true;
            this.base = h;
            if (this.base == document.body) {
                var g = {
                    dhx_skyblue: { t: 2, b: 2, l: 2, r: 2 },
                    dhx_web: { t: 8, b: 8, l: 8, r: 8 },
                    dhx_terrace: { t: 9, b: 9, l: 8, r: 8 },
                    material: { t: 9, b: 9, l: 8, r: 8 }
                };
                this.conf.ofs = (g[this.conf.skin] != null ? g[this.conf.skin] : g.dhx_skyblue);
            }
        }
        else {
            this.base = (typeof (h) == "string" ? document.getElementById(h) : h);
        }
        this.base.className += " " + this.conf.css + "_base_" + this.conf.skin;
        this.cont = document.createElement("DIV");
        this.cont.className = this.conf.css + "_cont";
        this.base.appendChild(this.cont);
        if (c != null) {
            this.setOffsets(c, false);
        }
        else {
            if (this.base._ofs != null) {
                this.setOffsets(this.base._ofs, false);
                this.base._ofs = null;
                try {
                    delete this.base._ofs;
                }
                catch (l) {
                }
            }
        }
        this._adjustCont = function () {
            var n = this.conf.ofs.t;
            for (var m in this.conf.ofs_nodes.t) {
                n += (this.conf.ofs_nodes.t[m] == true ? this.dataNodes[m].offsetHeight : 0);
            }
            var e = this.conf.ofs.b;
            for (var m in this.conf.ofs_nodes.b) {
                e += (this.conf.ofs_nodes.b[m] == true ? this.dataNodes[m].offsetHeight : 0);
            }
            this.cont.style.left = this.conf.ofs.l + "px";
            this.cont.style.width = this.base.clientWidth - this.conf.ofs.l - this.conf.ofs.r + "px";
            this.cont.style.top = n + "px";
            this.cont.style.height = this.base.clientHeight - n - e + "px";
        };
        this._setBaseSkin = function (e) {
            this.base.className = this.base.className.replace(new RegExp(this.conf.css + "_base_" + this.conf.skin, "gi"), this.conf.css + "_base_" + e);
        };
        this._initFSResize = function () {
            if (this.conf.fs_resize == true) {
                return;
            }
            this._doOnResizeStart = function () {
                window.clearTimeout(a.conf.fs_tm);
                a.conf.fs_tm = window.setTimeout(a._doOnResizeEnd, 200);
            };
            this._doOnResizeEnd = function () {
                a.setSizes();
            };
            if (typeof (window.addEventListener) == "function") {
                window.addEventListener("resize", this._doOnResizeStart, false);
            }
            else {
                window.attachEvent("onresize", this._doOnResizeStart);
            }
            this.conf.fs_resize = true;
        };
        if (this.conf.fs_mode == true) {
            this._initFSResize();
        }
        h = null;
    }
    dhtmlXCellTop.prototype._unloadTop = function () {
        this._mtbUnload();
        this.detachHeader();
        this.detachFooter();
        if (this.conf.fs_mode == true) {
            if (typeof (window.addEventListener) == "function") {
                window.removeEventListener("resize", this._doOnResizeStart, false);
            }
            else {
                window.detachEvent("onresize", this._doOnResizeStart);
            }
        }
        this.base.removeChild(this.cont);
        var e = new RegExp("s{0,}" + this.conf.css + "_base_" + this.conf.skin, "gi");
        this.base.className = this.base.className.replace(e, "");
        this.cont = this.base = null;
    };
    ;
    return dhtmlXCellTop;
})();
dhtmlXCellTop.prototype.setOffsets = function (l, h) {
    var g = false;
    for (var c in l) {
        var e = c.charAt(0);
        if (typeof (this.conf.ofs[e]) != "undefined" && !isNaN(l[c])) {
            this.conf.ofs[e] = parseInt(l[c]);
            g = true;
        }
    }
    if (h !== false && typeof (this.setSizes) == "function" && g == true) {
        this.setSizes();
    }
};
dhtmlXCellTop.prototype.attachStatusBar = function (a) {
    if (this.dataNodes.sbObj) {
        return;
    }
    if (typeof (a) == "undefined") {
        a = {};
    }
    this.dataNodes.sbObj = document.createElement("DIV");
    this.dataNodes.sbObj.className = "dhxcelltop_statusbar";
    if (this.cont.nextSibling != null) {
        this.base.insertBefore(this.dataNodes.sbObj, this.cont.nextSibling);
    }
    else {
        this.base.appendChild(this.dataNodes.sbObj);
    }
    this.dataNodes.sbObj.innerHTML = "<div class='dhxcont_statusbar'>" + (typeof (a.text) == "string" && a.text.length > 0 ? a.text : "&nbsp;") + "</div>";
    if (typeof (a.height) == "number") {
        this.dataNodes.sbObj.firstChild.style.height = this.dataNodes.sbObj.firstChild.style.lineHeight = a.height + "px";
    }
    this.dataNodes.sbObj.setText = function (c) {
        this.childNodes[0].innerHTML = c;
    };
    this.dataNodes.sbObj.getText = function () {
        return this.childNodes[0].innerHTML;
    };
    this.dataNodes.sbObj.onselectstart = function (c) {
        return false;
    };
    this.dataNodes.sbEv = this.attachEvent("_onSetSizes", function () {

        var thisObj = this;
        if (thisObj.dataNodes.sbObj.style.display == "none") {
            return;
        }
        thisObj.dataNodes.sbObj.style.left = thisObj.conf.ofs.l + "px";
        thisObj.dataNodes.sbObj.style.bottom = (thisObj.dataNodes.faObj != null ? thisObj.dataNodes.faObj.offsetHeight : 0) + thisObj.conf.ofs.t + "px";
        thisObj.dataNodes.sbObj.style.width = thisObj.base.offsetWidth - thisObj.conf.ofs.l - thisObj.conf.ofs.r + "px";
    });
    this.conf.ofs_nodes.b.sbObj = true;
    this.setSizes();
    return this.dataNodes.sbObj;
};
dhtmlXCellTop.prototype.detachStatusBar = function () {
    if (!this.dataNodes.sbObj) {
        return;
    }
    this.dataNodes.sbObj.setText = this.dataNodes.sbObj.getText = this.dataNodes.sbObj.onselectstart = null;
    this.dataNodes.sbObj.parentNode.removeChild(this.dataNodes.sbObj);
    this.dataNodes.sbObj = null;
    this.detachEvent(this.dataNodes.sbEv);
    this.dataNodes.sbEv = null;
    this.conf.ofs_nodes.b.sbObj = false;
    delete this.dataNodes.sb;
    delete this.dataNodes.sbObj;
    delete this.dataNodes.sbEv;
    if (!this.conf.unloading) {
        this.setSizes();
    }
};
dhtmlXCellTop.prototype.showMenu = function () {
    this._mtbShowHide("menuObj", "");
};
dhtmlXCellTop.prototype.hideMenu = function () {
    this._mtbShowHide("menuObj", "none");
};
dhtmlXCellTop.prototype.showToolbar = function () {
    this._mtbShowHide("toolbarObj", "");
};
dhtmlXCellTop.prototype.hideToolbar = function () {
    this._mtbShowHide("toolbarObj", "none");
};
dhtmlXCellTop.prototype.showStatusBar = function () {
    this._mtbShowHide("sbObj", "");
};
dhtmlXCellTop.prototype.hideStatusBar = function () {
    this._mtbShowHide("sbObj", "none");
};
dhtmlXCellTop.prototype._mtbShowHide = function (c, a) {
    if (this.dataNodes[c] == null) {
        return;
    }
    this.dataNodes[c].style.display = a;
    this.setSizes();
};
dhtmlXCellTop.prototype._mtbUnload = function (c, a) {
    this.detachMenu();
    this.detachToolbar();
    this.detachStatusBar();
    this.detachRibbon();
};
dhtmlXCellTop.prototype.getAttachedMenu = function () {
    return this.dataNodes.menu;
};
dhtmlXCellTop.prototype.getAttachedToolbar = function () {
    return this.dataNodes.toolbar;
};
dhtmlXCellTop.prototype.getAttachedRibbon = function () {
    return this.dataNodes.ribbon;
};
dhtmlXCellTop.prototype.getAttachedStatusBar = function () {
    return this.dataNodes.sbObj;
};
dhtmlXCellTop.prototype.progressOn = function () {
    if (this.conf.progress) {
        return;
    }
    this.conf.progress = true;
    var c = document.createElement("DIV");
    c.className = "dhxcelltop_progress";
    this.base.appendChild(c);
    var a = document.createElement("DIV");
    if (this.conf.skin == "material" && (window.dhx4.isFF || window.dhx4.isChrome || window.dhx4.isOpera || window.dhx4.isEdge)) {
        a.className = "dhxcelltop_progress_svg";
        a.innerHTML = '<svg class="dhx_cell_prsvg" viewBox="25 25 50 50"><circle class="dhx_cell_prcircle" cx="50" cy="50" r="20"/></svg>';
    }
    else {
        a = document.createElement("DIV");
        a.className = "dhxcelltop_progress_img";
    }
    this.base.appendChild(a);
    c = a = null;
};
dhtmlXCellTop.prototype.progressOff = function () {
    if (!this.conf.progress) {
        return;
    }
    var g = { dhxcelltop_progress: true, dhxcelltop_progress_img: true, dhxcelltop_progress_svg: true };
    for (var e = 0; e < this.base.childNodes.length; e++) {
        if (typeof (this.base.childNodes[e].className) != "undefined" && g[this.base.childNodes[e].className] == true) {
            g[this.base.childNodes[e].className] = this.base.childNodes[e];
        }
    }
    for (var c in g) {
        if (g[c] != true) {
            this.base.removeChild(g[c]);
        }
        g[c] = null;
    }
    this.conf.progress = false;
    g = null;
};
dhtmlXCellTop.prototype.attachHeader = function (c, a) {
    if (this.dataNodes.haObj != null) {
        return;
    }
    if (typeof (c) != "object") {
        c = document.getElementById(c);
    }
    this.dataNodes.haObj = document.createElement("DIV");
    this.dataNodes.haObj.className = "dhxcelltop_hdr";
    this.dataNodes.haObj.style.height = (a || c.offsetHeight) + "px";
    this.base.insertBefore(this.dataNodes.haObj, this.dataNodes.menuObj || this.dataNodes.toolbarObj || this.cont);
    this.dataNodes.haObj.appendChild(c);
    c.style.visibility = "visible";
    c = null;
    this.dataNodes.haEv = this.attachEvent("_onSetSizes", function () {

        var thisObj = this;
        thisObj.dataNodes.haObj.style.left = thisObj.conf.ofs.l + "px";
        thisObj.dataNodes.haObj.style.marginTop = thisObj.conf.ofs.t + "px";
        thisObj.dataNodes.haObj.style.width = thisObj.base.offsetWidth - thisObj.conf.ofs.l - thisObj.conf.ofs.r + "px";
    });
    this.conf.ofs_nodes.t.haObj = true;
    this.setSizes();
};
dhtmlXCellTop.prototype.detachHeader = function () {
    if (!this.dataNodes.haObj) {
        return;
    }
    while (this.dataNodes.haObj.childNodes.length > 0) {
        this.dataNodes.haObj.lastChild.style.visibility = "hidden";
        document.body.appendChild(this.dataNodes.haObj.lastChild);
    }
    this.dataNodes.haObj.parentNode.removeChild(this.dataNodes.haObj);
    this.dataNodes.haObj = null;
    this.detachEvent(this.dataNodes.haEv);
    this.dataNodes.haEv = null;
    this.conf.ofs_nodes.t.haObj = false;
    delete this.dataNodes.haEv;
    delete this.dataNodes.haObj;
    if (!this.conf.unloading) {
        this.setSizes();
    }
};
dhtmlXCellTop.prototype.attachFooter = function (e, a) {
    if (this.dataNodes.faObj != null) {
        return;
    }
    if (typeof (e) != "object") {
        e = document.getElementById(e);
    }
    this.dataNodes.faObj = document.createElement("DIV");
    this.dataNodes.faObj.className = "dhxcelltop_ftr";
    this.dataNodes.faObj.style.height = (a || e.offsetHeight) + "px";
    var c = (this.dataNodes.sbObj || this.cont);
    if (this.base.lastChild == c) {
        this.base.appendChild(this.dataNodes.faObj);
    }
    else {
        this.base.insertBefore(this.dataNodes.faObj, c.nextSibling);
    }
    this.dataNodes.faEv = this.attachEvent("_onSetSizes", function () {

        var thisObj = this;
        thisObj.dataNodes.faObj.style.left = thisObj.conf.ofs.l + "px";
        thisObj.dataNodes.faObj.style.bottom = thisObj.conf.ofs.b + "px";
        thisObj.dataNodes.faObj.style.width = thisObj.base.offsetWidth - thisObj.conf.ofs.l - thisObj.conf.ofs.r + "px";
    });
    this.dataNodes.faObj.appendChild(e);
    e.style.visibility = "visible";
    c = e = null;
    this.conf.ofs_nodes.b.faObj = true;
    this.setSizes();
};
dhtmlXCellTop.prototype.detachFooter = function () {
    if (!this.dataNodes.faObj) {
        return;
    }
    while (this.dataNodes.faObj.childNodes.length > 0) {
        this.dataNodes.faObj.lastChild.style.visibility = "hidden";
        document.body.appendChild(this.dataNodes.faObj.lastChild);
    }
    this.dataNodes.faObj.parentNode.removeChild(this.dataNodes.faObj);
    this.dataNodes.faObj = null;
    this.detachEvent(this.dataNodes.faEv);
    this.dataNodes.faEv = null;
    this.conf.ofs_nodes.b.faObj = false;
    delete this.dataNodes.faEv;
    delete this.dataNodes.faObj;
    if (!this.conf.unloading) {
        this.setSizes();
    }
};

export default dhtmlXCellTop;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXLayoutObject/dhtmlXCellTop.js